;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.4";import * as Sentry from '@sentry/nextjs';

import {
  beforeSend,
  browserExtensionUrls,
  rememberSyntheticRejection,
  shouldCreateSpanForRequest,
} from './utils/capture';

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;

if (SENTRY_DSN) {
  // Registered before Sentry.init installs its own handler, so it sees each
  // rejection event before Sentry reports it.
  window.addEventListener('unhandledrejection', rememberSyntheticRejection);

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_NODE_ENV,
    tracesSampleRate: 0.1,
    integrations: [
      Sentry.browserTracingIntegration({ shouldCreateSpanForRequest }),
    ],
    ignoreErrors: [
      // Thrown by the script the Facebook Android in-app browser injects
      // (navigation_performance_logger_android) when its native bridge is
      // torn down on beforeunload. Not our code and not user-facing.
      'Java object is gone',
      // Same script in the Instagram Android in-app browser, when the bridge's
      // Java side throws instead of being gone. Only a WebView JavaScript
      // interface raises this, and we never register one.
      'Java exception was raised during method invocation',
      // The iOS twin: the Instagram in-app browser's injected
      // sendPageHideMessage script reads window.webkit.messageHandlers on
      // pagehide after its native bridge is gone. Not our code either.
      'window.webkit.messageHandlers',
      // Sentry appends the host to a failed fetch's "Load failed" / "Failed to
      // fetch" / "NetworkError…" message. We only load Storyblok images through
      // <img>, never fetch(), so a failed fetch to a.storyblok.com comes from
      // the browser re-fetching images itself (seen from Opera Touch on iOS).
      '(a.storyblok.com)',
      // Raised by Safari when a Safari Web Extension's content script messages
      // its background page after its tab has gone. The extension leaves the
      // rejection unhandled and it has no stack, so Sentry reports it as ours.
      // We never call runtime.sendMessage.
      'Invalid call to runtime.sendMessage()',
      // Rejected by CefSharp's JS bridge when a host-injected script calls a
      // .NET object that isn't bound — seen from the headless browser
      // Microsoft's email link scanners (Safe Links) open our links in. No
      // stack, no users, and we never register a CefSharp bridge.
      'Object Not Found Matching Id:',
      // WebKit rejects with this when an injected script posts to
      // window.webkit.messageHandlers and the host app never replies — seen
      // from DuckDuckGo on iOS. We register no message handlers.
      'WKWebView API client did not respond to this postMessage',
      // The Facebook Android in-app browser's injected script calling its
      // native bridge before the app has set it up.
      'iabjs_unified_bridge',
    ],
    denyUrls: browserExtensionUrls,
    beforeSend,
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
